/** @format */
import React from 'react'

import Button from '../../components/tailwind/Button'
import Splash from '../../components/tailwind/Splash'

export function SetUpTeamSplash({onSetUpClick}) {
  return (
    <Splash
      title={'Teams'}
      description={'Collaborate with teammates to create and manage forms'}
    >
      <Button primary onClick={onSetUpClick}>
        Set up a Team
      </Button>
    </Splash>
  )
}
